import React, { useState } from 'react'
import './PublishPreviewQB.css'
import ConfirmPopUp from '../PublishQB/ConfirmPopUp'
import McqDisplayMcq from './McqDisplay'
import AttachDisplay from './AttachDisplay'
import PublishQb from '../PublishQB/PublishQbUpdate'
export default function PublishPreviewQB({ setPreview, displayQuestions, details, type }) {
    const [publishQb, setPubishQb] = useState()
    return (
        <div className='total_Container_Preview_Qb'>
            {!publishQb && (
                <div className='ForCross'>
                    <div className='total_SubContainer_Preview_Qb p-4'>
                        <div className='d-flex justify-content-between'>
                            <div className='QbPreview_heading'>{details?.name}</div>
                            <button onClick={(e) => { setPubishQb(true) }} className='PublishBtn_preview'>Publish</button>
                        </div>
                        {displayQuestions?.length > 0 &&
                            displayQuestions?.map((question, index) =>
                                question?.options?.length > 0 ? (
                                    <McqDisplayMcq
                                        key={index}
                                        nextQuestion={index}
                                        question={question}
                                    />
                                ) : (
                                    <AttachDisplay
                                        nextQuestion={index}
                                        question={question}
                                    />
                                )
                            )}
                    </div>
                    <div className='CrossPreviewQB_CM'>
                        <img onClick={(e) => setPreview(false)} src='/ContentM_images/cross_icon_cm.svg' alt='cross logo'></img>
                    </div>
                </div>
            )}

            {/* {publishQb && type==="create" && <PublishQb setPubishQb={setPubishQb} questions={displayQuestions} basicDetails={details}/>} */}
            {publishQb && type === "create" && <ConfirmPopUp close={setPubishQb} questions={displayQuestions} basicDetails={details} type={"create"} />}
            {publishQb && type !== "create" && <ConfirmPopUp close={setPubishQb} questions={displayQuestions} basicDetails={details} />}
        </div>

    )
}
